<template>
    <div
        :class="{
            'app-text': true,
            'app-text--dark': dark
        }"
    >
        {{ value }}
    </div>
</template>

<script>
export default {
    name: 'AppText',
    props: {
        value: {
            type: String,
            required: true
        },
        dark: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.app-text {
    &--dark {
        color: #8f9da6;
    }
}
</style>
